import { FormControl, TextField } from "@mui/material";
import { useSnackbar } from "notistack";
import React from "react";

export default function RejectReason({ reason, setReason, setOpenReject }) {
  const { enqueueSnackbar } = useSnackbar();
  const handleChange = (event) => {
    const value = event.target.value;
    setReason(value);
  };
  const handleSubmit = (e) => {
    if (reason == "") {
      enqueueSnackbar("Reject Reason is Required", { variant: "error" });
    } else {
      setOpenReject(true);
    }
  };
  return (
    <div className="container new-memories px-4">
      <div className="col-lg-12 col-md-12 col-sm-12 mt-4">
        <FormControl fullWidth>
          <TextField
            id="outlined-multiline-flexible"
            label="Reject Reason"
            multiline
            rows={6}
            name="reason"
            value={reason}
            onChange={handleChange}
            required
          />
        </FormControl>
      </div>
      <div className="col-l2 text-end mt-3">
        <button className="small-contained-button" onClick={handleSubmit}>
          Submit
        </button>
      </div>
    </div>
  );
}
